// extracted by mini-css-extract-plugin
export default {"layout":"QO-VS","index":"U30+P"};